// src/components/pcr/common/SectionHeading.tsx
import React from 'react';

interface SectionHeadingProps {
  title: string;
  description?: string;
}

const SectionHeading: React.FC<SectionHeadingProps> = ({ title, description }) => {
  return (
    <h3 className="text-lg font-semibold text-gray-800 mb-2">
      {title}
      {description && (
        <p className="text-sm text-gray-600 mb-4 italic whitespace-pre-line">
          {description}
        </p>
      )}
    </h3>
  );
};

export default SectionHeading;





